function drawWatermark({ watermarkName, fontSize, exitButtonText, onClickExit } = {}) {
  const NAMESPACE = 'xfe-preview-water-mark'
  const CONTAINER_ID = NAMESPACE + '-container'
  const targetDom = document.getElementById(CONTAINER_ID) || document.createElement('div')

  const drawWatermarkName = watermarkName || `禁止对外使用`
  const drawFontSize = fontSize || 20

  if (!targetDom.id) {
    targetDom.id = CONTAINER_ID
    targetDom.style.cssText = `
            position:fixed;top:0;left:0;width:100%;height:100%;
            z-index:9999;pointer-events:none;overflow:hidden;
        `
    document.body.appendChild(targetDom)
  }

  const drawWatermarkDom = (text, exitButtonText) => {
    const settings = {
      txt: text,
      x: 6,
      y: 10,
      row: 20,
      col: 20,
      xSpace: 20,
      ySpace: 40,
      color: '#999',
      alpha: 0.15,
      fontSize: `${drawFontSize}px`,
      font: '微软雅黑',
      width: 200,
      height: 180,
      angle: 20,
    }
    const fragment = document.createDocumentFragment()
    for (let i = 0; i < settings.row; i++) {
      for (let j = 0; j < settings.col; j++) {
        const div = document.createElement('div')
        div.textContent = settings.txt
        div.style.cssText = `
                    position:absolute;
                    left:${settings.x + (settings.width + settings.xSpace) * j}px;
                    top:${settings.y + (settings.height + settings.ySpace) * i}px;
                    transform:rotate(-${settings.angle}deg);
                    opacity:${settings.alpha};
                    color:${settings.color};
                    font-size:${settings.fontSize};
                    font-family:${settings.font};
                    text-align:center;
                    width:${settings.width}px;
                    height:${settings.height}px;
                    display:block;
                    z-index:9999;
                    pointer-events:none;
                `
        fragment.appendChild(div)
      }
    }
    targetDom.appendChild(fragment)

    // 绘制退出按钮
    if (exitButtonText) {
      const exitButton = document.createElement('div')
      exitButton.textContent = exitButtonText
      exitButton.style.cssText = `
                position:absolute;
                right: 60px;
                top: 60px;
                color: #fff;
                font-size: ${settings.fontSize};
                font-family: ${settings.font};
                text-align:center;
                padding: 10px 20px;
                background-color: rgb(255, 77, 79);
                border-radius: 4px;
                cursor: pointer;
                display:block;
                z-index:9999;
                pointer-events:auto;
                user-select: none;
            `
      if (onClickExit && typeof onClickExit === 'function') {
        exitButton.addEventListener('click', onClickExit)
      }
      targetDom.appendChild(exitButton)
    }
  }

  drawWatermarkDom(drawWatermarkName, exitButtonText)
}

export default drawWatermark
